export default "__VITE_ASSET__DXiMN90z__"